
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import AutocompleteExperimental from '@hokify/shared-components/lib/components/Autocomplete/AutocompleteExperimental.vue';
import LocationAutocompleteExperimental from '@hokify/shared-components/lib/components/LocationAutocomplete/LocationAutocompleteExperimental.vue';

const valuesStore = namespace('values');
const locationStore = namespace('location');

@Component({
	name: 'SearchbarPage',
	components: { AutocompleteExperimental, LocationAutocompleteExperimental },
	layout: 'plain-user',
	scrollToTop: true
})
export default class SearchbarPage extends Vue {
	@valuesStore.Action('ontologyKeywordSuggestion') ontologyKeywordSuggestion;

	@locationStore.Action('resolveGeoCoords') resolveGeoCoords;

	branch = '';

	city = '';

	updateBranch(
		searchTerm: string,
		_event,
		_parameters?: { term: string; type: string; data?: { alias?: string } }
	) {
		this.branch = searchTerm;
	}

	selectBranch(
		_searchTerm: string,
		parameters?: { term: string; type: string; data?: { alias?: string } }
	) {
		if (parameters?.type === 'company' && parameters?.data?.alias) {
			this.$router.push({ path: `/c/${parameters.data.alias}` });
		}
	}

	mapSuggestionType(type: 'company' | 'keyword') {
		return type === 'company' ? 'Firma' : 'Job';
	}

	handleJobSearchExperimental() {
		this.$router.push({
			path: '/jobs/search',
			query: {
				branch: this.branch,
				city: this.city
			}
		});
	}
}
